import firebase from 'firebase/app'


/**
 * Get all info about an user
 * @param {String} id - The id of the user
 * @returns {User} The user object
 */
const createCasting = async (data) => {
  const db = firebase.firestore()
  const doc = await db.collection('castings').add({
    ...data,
    description: '',
    display_date: '',
    is_opened: false,
    is_visible: false,
    display_location: '',
    created_at: new Date(),
  })

  const snapshot = await db.collection('castings').doc(doc.id).get()
  const result = snapshot.data()

  return {
    ...result,
    id: snapshot.id,
    created_at: result.created_at.toDate(),
  }
}


export default createCasting
